/* eslint-disable no-fallthrough */
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Form, Field, change } from "redux-form";
import { setLoading, reset, initializeForm } from "../../../../helpers/redux";
import moment from 'moment';
import 'moment/locale/pt-br';
import _ from 'lodash';

import { API_STATIC, USER_TOKEN, BASE_API } from "../../../../config/consts";

import EmptyChart from "../../../../assets/images/empty-chart.png";
import Button from "../../../../common/components/ui/button/button";
import Loading from "../../../../common/components/ui/loading/loading";
import Modal from "../../../../common/components/ui/modals/defaultModal/defaultModal";

import { getListFiltered as getMyCharts } from "../myCharts/myChartsActions";

import fields from "./form/fieldsDefault";
import fieldsSelect from "./form/fieldsSelect";
import fieldsSolar from "./form/fieldsSolar";
import fieldsMoon from "./form/fieldsMoon";
import fieldsTransits from "./form/fieldsTransits";
import types from "./homeTypes";
import { drawChart, saveChart, drawSolarRevolution, drawMoonRevolution, drawTransits, chartToPrint } from "./homeActions";
import { dateFormat2Save, dateFormat2Show } from "../../../../helpers/dataTransformers";
import ChartBox from "../../../../common/components/chartBox/chartBox";
import axios from "axios";

moment.locale('pt-br');

const URL = `${BASE_API}/cities/`;

class Home extends Component {
    constructor(props) {
        super(props);
        const fields = "name,person_name,hour,daylight_savings,birthday,city.lat,city.lon,city.timezone,houses";
        if(this.props.home.drawChart1.chart === '') {
            this.props.setLoading(types.HOME_LOADING, true);
            this.props.getMyCharts(this.props.auth.user._id, fields, 'limit=999999');
        }
        this.state = {
            updated: false,
            isVisible: false,
            visibleSelect: false,
            isVisibleSolar: false,
            isVisibleMoon: false,
            isVisibleTransits: false,
            chartToDraw: null,
            chartToPrint: null,
            expanded: false,
            chart1: {},
            chart2: {},
            formType: "",
            chart1Type: "",
            chart2Type: ""
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const { content } = this.props.myCharts.list;
        if(this.props.home.drawChart1.chart === '') {
            if (content.length > 0 && !this.state.updated) {
                this.setState({
                    chart1: content[content.length - 1],
                    chart1Type: "natal",
                    chart2: content[content.length - 1],
                    chart2Type: "natal",
                    chartToPrint: content[content.length - 1]
                });

                this.props.setLoading(types.HOME_LOADING, true);
                this.setState({
                    updated: true
                });
                setTimeout(() => {
                    this.startDraw();
                }, 500);
            }
        } else if (this.props.home.drawChart1.chart !== '' && !this.state.updated) {
            this.props.setLoading(types.HOME_LOADING, true);
            this.setState({
                chart1: this.props.home.birthChart1,
                chart1Type: "natal",
                chart2: this.props.home.birthChart2,
                chart2Type: "natal",
                updated: true
            });

            setTimeout(() => {
                this.props.drawChart(this.props.home.birthChart1, types.CHART1_DRAWN);
                this.props.drawChart(this.props.home.birthChart2, types.CHART2_DRAWN);
            }, 500);
        }
    }

    drawDefault = () => {
        this.props.drawChart(this.state.chart1, types.CHART_DRAWN_BOTH)
    }

    startDraw = (chart = null, typeDraw, typeChart=null) => {
        if(typeChart !== null) {
            this.setState({
                ['chart'+typeChart.number+'Type']: typeChart.type
            })
        }
        _.isNull(chart) ?
        this.drawDefault()
        :
        this.props.drawChart(this.state[chart], types[typeDraw])       
    };

    onSubmit = values => {
        if (values._id) {
            delete values['_id']
        }
        const newValues = {
            ...values,
            daylight_savings: values.daylight_savings ? values.daylight_savings : false,
            person_name: values.person_name.trim(),
            name: values.name.trim(),
            city: values.city.item,
            birthday: dateFormat2Save(values.birthday, "/"),
            user: this.props.auth.user._id
        };
        this.closeForm();
        this.props.saveChart(newValues);
    };

    toggleExpand = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    closeForm = () => {
        setTimeout(() => {
            this.props.reset("chartForm");
        }, 500);
        this.setState({
            isVisible: false,
            visibleSelect: false,
            isVisibleSolar: false,
            isVisibleMoon: false,
            isVisibleTransits: false
        });
    };

    promiseOptions = inputValue => {
        let filterValues = "country_letters(BR)"
        if (inputValue !== "") {
            if(inputValue.split("-").length > 1){
                filterValues = `name(^${inputValue.split("-")[0].trim()}),country_letters(${inputValue.split("-")[1].trim()})`
            } else {
                filterValues = `name(^${inputValue})`
            }
        }
        return axios.get(`${URL}?limit=50&like=${filterValues}&sort=name[asc]&populate=state`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            let listCities = [];
            listCities = response.data.content.map(item => ({
                label: item.name + ` - ${item.state ? item.state.name+' - ' : ''}`+ item.country_letters,
                value: item._id,
                item: item
            })
            )
            return listCities;

        }).catch((err) => {
            console.log(err)
            return null
        })
    };

    handleChangeInput = (value, type) => {
    }

    renderFields = () => {
        return fields(this.promiseOptions,this.handleChangeInput).map((item, index) => <Field {...item} key={index} />);
    };

    renderOptionsCharts = () => {
        return this.props.myCharts.list.content.map(item => ({
            label: item.person_name,
            value: item._id,
            item: item
        }));
    };

    renderOptionsMonth = () => {
        return [
            { label: "Janeiro", value: 1 },
            { label: "Fevereiro", value: 2 },
            { label: "Março", value: 3 },
            { label: "Abril", value: 4 },
            { label: "Maio", value: 5 },
            { label: "Junho", value: 6 },
            { label: "Julho", value: 7 },
            { label: "Agosto", value: 8 },
            { label: "Setembro", value: 9 },
            { label: "Outubro", value: 10 },
            { label: "Novembro", value: 11 },
            { label: "Dezembro", value: 12 }
        ];
    };

    renderFieldsSelect = () => {
        return fieldsSelect(this.renderOptionsCharts).map((item, index) => <Field {...item} key={index} />);
    };

    renderFieldsSolar = () => {
        return fieldsSolar(this.promiseOptions).map((item, index) => <Field {...item} key={index} />);
    };

    renderFieldsMoon = () => {
        return fieldsMoon(this.renderOptionsMonth, this.promiseOptions).map((item, index) => <Field {...item} key={index} />);
    };

    renderFieldsTransits = () => {
        return fieldsTransits().map((item, index) => <Field {...item} key={index} />);
    };

    onSelectChart = values => {
        let choice = '';
        let typeDraw = '';
        let typeChart = {};
        this.closeForm();
        this.props.setLoading(types.HOME_LOADING, true);
        if (this.state.chartToDraw === 1) {
            choice ='chart1';
            typeDraw='CHART1_DRAWN'
            typeChart={number: 1, type: 'natal'};
            this.setState({
                chart1: values.chart.item
            })
        } else {
            choice='chart2';
            typeDraw='CHART2_DRAWN';
            typeChart={number: 2, type: 'natal'};
            this.setState({
                chart2: values.chart.item
            })
        }

        setTimeout(() => {
            this.startDraw(choice, typeDraw, typeChart);
        }, 500);
    };

    backToNatal = (chart, chartToDraw) => {
        this.props.setLoading(types.HOME_LOADING, true);
        this.setState({
            [`chart${chartToDraw}`]: this.props.home[`birthChart${chartToDraw}`]
        });
        setTimeout(() => {
            chartToDraw === 1
            ? this.setState({ chart1Type: "natal" }, this.props.drawChart(this.state.chart1, types.CHART1_DRAWN))
            : this.setState({ chart2Type: "natal" }, this.props.drawChart(this.state.chart2, types.CHART2_DRAWN));
        }, 500);
    }

    openChartModal = (chart, chartToDraw) => {
        this.setState({
            visibleSelect: true, chartToDraw, formType: "selectChart"
        })
    }

    openSolarModal = (chart, chartToDraw) => {
        const formData = {
            _id: this.props.home['birthChart'+chartToDraw]._id,
            name: this.props.home['birthChart'+chartToDraw].name,
            person_name: this.props.home['birthChart'+chartToDraw].person_name,
            birthday: dateFormat2Show(this.props.home['birthChart'+chartToDraw].birthday, '/'),

            hour: this.props.home['birthChart'+chartToDraw].hour,
            daylight_savings: this.props.home['birthChart'+chartToDraw].daylight_savings,
            year: moment().format('YYYY')
        };

        this.setState({
            isVisibleSolar: true,
            chartToDraw,
            formType: "solarChart"
        });
        this.props.reset("chartForm");
        this.props.initializeForm("chartForm", formData);
    };

    onSolarRevolution = values => {
        const newValues = {
            ...values,
            ...this.props.home['birthChart'+this.state.chartToDraw],
            returnCity: {
                ...values.returnCity.item
            },
            birthday: dateFormat2Save(values.birthday, "/"),
            user: this.props.auth.user._id,
            year: Number(values.year)
        };
        this.closeForm();
        this.props.setLoading(types.HOME_LOADING, true);
        this.setState(
            {
                [`chart${this.state.chartToDraw}`]: newValues,
                [`chart${this.state.chartToDraw}Type`]: "solar"
            },
            this.props.drawSolarRevolution(newValues, `CHART${this.state.chartToDraw}_DRAWN`)
        );
    };

    openTransitsModal = (chart, chartToDraw) => {
        const formData = {
            _id: this.props.home['birthChart'+chartToDraw]._id,
            name: this.props.home['birthChart'+chartToDraw].name,
            person_name: this.props.home['birthChart'+chartToDraw].person_name,
            birthday: dateFormat2Show(this.props.home['birthChart'+chartToDraw].birthday, '/'),
            hour: this.props.home['birthChart'+chartToDraw].hour,
            daylight_savings: this.props.home['birthChart'+chartToDraw].daylight_savings,
            city: this.props.home['birthChart'+chartToDraw].city,
            year: moment().format('YYYY')

        };

        this.setState({
            isVisibleTransits: true,
            chartToDraw,
            formType: "transitsChart"
        });
        this.props.reset("chartForm");
        this.props.initializeForm("chartForm", formData);
    };

    onTransitsRevolution = values => {
        const newValues = {
            ...values,
           
            birthday: dateFormat2Save(values.birthday, "/"),
            user: this.props.auth.user._id,
            year: Number(values.year)
        };
        this.closeForm();
        this.props.setLoading(types.HOME_LOADING, true);

        this.setState(
            {
                [`chart${this.state.chartToDraw}`]: newValues,
                [`chart${this.state.chartToDraw}Type`]: "transito"
            },
            this.props.drawTransits(newValues, `CHART${this.state.chartToDraw}_DRAWN`)
        );
    };

    openMoonModal = (chart, chartToDraw) => {
        const formData = {
            _id: this.props.home['birthChart'+chartToDraw]._id,
            name: this.props.home['birthChart'+chartToDraw].name,
            person_name: this.props.home['birthChart'+chartToDraw].person_name,
            birthday: dateFormat2Show(this.props.home['birthChart'+chartToDraw].birthday, '/'),
            hour: this.props.home['birthChart'+chartToDraw].hour,
            daylight_savings: this.props.home['birthChart'+chartToDraw].daylight_savings,
            year: moment().format('YYYY')
        };

        this.setState({
            isVisibleMoon: true,
            chartToDraw,
            formType: "moonChart"
        });
        this.props.reset("chartForm");
        this.props.initializeForm("chartForm", formData);
    };

    onMoonRevolution = values => {
        const newValues = {
            ...values,
            ...this.props.home['birthChart'+this.state.chartToDraw],
            returnCity: {
                ...values.returnCity.item
            },
            // birthday: dateFormat2Save(values.birthday, "/"),
            user: this.props.auth.user._id,
            year: Number(values.year),
            month: values.month.value
        };
        this.closeForm();
        this.props.setLoading(types.HOME_LOADING, true);

        this.setState(
            {
                [`chart${this.state.chartToDraw}`]: newValues,
                [`chart${this.state.chartToDraw}Type`]: "lunar"
            },
            this.props.drawMoonRevolution(newValues, `CHART${this.state.chartToDraw}_DRAWN`)
        );
    };

    printChart = (chartToPrint, chartToDraw) => {
        let chartType = '';
        let images = {};
        let birth = {};
        this.props.setLoading(types.HOME_PRINT_LOADING, true);
       
        chartToDraw === 1
        ? 
            chartType=this.state.chart1Type
        : 
            chartType=this.state.chart2Type;   
        chartToDraw === 1
        ? 
            images=this.props.home.drawChart1
        : 
            images=this.props.home.drawChart2;
        chartToDraw === 1
        ? 
            birth=this.props.home.birthChart1
        : 
            birth=this.props.home.birthChart2;

        const chart = { 
            data:this.state[chartToPrint],
            images,
            birth
        }
        const values = {
            chart,
            chartType
        }
        this.props.chartToPrint(values)
        setTimeout(() => {
            this.props.router.push('/imprimir');
        }, 500);
    }

    renderCordinates = (lat, lon) => {
        let latConv = '', lonConv = '';
        if (lat.substr(0,1)==='-') {
            latConv=`${lat.substr(1,2)}°${lat.substr(4,2)}' S`;
        } else {
            latConv=`${lat.substr(0,2)}°${lat.substr(3,2)}' N`;;
        }
        if (lon.substr(0,1)==='-') {
            lonConv=`${lon.substr(1,2)}°${lon.substr(4,2)}' W`;
        } else {
            lonConv=`${lon.substr(0,2)}°${lon.substr(3,2)}' E`;;
        }

        return `${latConv} ${lonConv}`

    }

    renderCharts = () => {
        const { content } = this.props.myCharts.list;
        const { drawChart1, birthChart1, drawChart2, birthChart2 } = this.props.home;
        if (content.length === 0 || _.isUndefined(birthChart1.city)) {
            return (
                <div>
                    <div className="home__chart1--content-empty">
                        <img
                            src={EmptyChart}
                            alt="Não há mapa"
                            style={{ height: "100%", width: "21rem", marginTop: "30vh" }}
                        />
                    </div>
                    <span className="home__chart1--subtitle-empty">Não há mapas cadastrados</span>
                </div>
            );
        } else {
            return (
                <div
                    className={
                        this.state.expanded ? "container-flex--center" : "container-flex--center margin-top-medium"
                    }
                    style={{paddingBottom: '8rem'}}
                >
                    <ChartBox
                        chartNumber={1}
                        chartType={this.state.chart1Type}
                        item={{
                            ...drawChart1,
                            chart_image: `${API_STATIC}/${drawChart1.chart}`,
                            aspects_image: `${API_STATIC}/${drawChart1.aspects}`
                        }}
                        birth={birthChart1}
                        expanded={this.state.expanded}
                        toggleExpand={this.toggleExpand}
                        solarModal={this.openSolarModal}
                        moonModal={this.openMoonModal}
                        transitsModal={this.openTransitsModal}
                        backToNatal={this.backToNatal}
                        chartModal={this.openChartModal}
                        chartPrint={this.printChart}
                    />
                    <ChartBox
                        chartNumber={2}
                        chartType={this.state.chart2Type}
                        item={{
                            ...drawChart2,
                            chart_image: `${API_STATIC}/${drawChart2.chart}`,
                            aspects_image: `${API_STATIC}/${drawChart2.aspects}`
                        }}
                        birth={birthChart2}
                        expanded={this.state.expanded}
                        toggleExpand={this.toggleExpand}
                        solarModal={this.openSolarModal}
                        moonModal={this.openMoonModal}
                        transitsModal={this.openTransitsModal}
                        backToNatal={this.backToNatal}
                        chartModal={this.openChartModal}
                        chartPrint={this.printChart}
                    />
                </div>
            );
        }
    };

    renderSelectChart = () => {
        const { handleSubmit } = this.props;
        return (
            <Modal
                isVisible={this.state.visibleSelect}
                title="Selecione um mapa"
                id="modal-select"
                children={
                    <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                        <Form role="form" onSubmit={handleSubmit(this.onSelectChart)} noValidate>
                            <div className="form__body">{this.renderFieldsSelect()}</div>
                            <div className="form__footer">
                                <div className="form__footer--actions">
                                    <Button
                                        text="Cancelar"
                                        type="button"
                                        rounded
                                        colors={"#f1c40f"}
                                        textStyle={{ color: "#555" }}
                                        outline
                                        onClick={this.closeForm}
                                    />
                                    <Button
                                        text="Carregar"
                                        type="submit"
                                        // style={{ width: "25%" }}
                                        rounded
                                        buttonType="primary"
                                        textStyle={{ color: "#555" }}
                                        outline
                                        // animated
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            />
        );
    };

    renderCreateChart = () => {
        const { handleSubmit } = this.props;

        return (
            <Modal
                isVisible={this.state.isVisible}
                title="Novo mapa natal"
                id="modal-select"
                children={
                    <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                        <Form role="form" onSubmit={handleSubmit(this.onSubmit)} noValidate>
                            <div className="form__body">{this.renderFields()}</div>
                            <div className="form__footer">
                                <div className="form__footer--actions">
                                    <Button
                                        text="Cancelar"
                                        type="button"
                                        rounded
                                        colors={"#f1c40f"}
                                        textStyle={{ color: "#555" }}
                                        outline
                                        onClick={this.closeForm}
                                    />
                                    <Button
                                        text="Gerar e Salvar"
                                        type="submit"
                                        // style={{ width: "25%" }}
                                        rounded
                                        buttonType="primary"
                                        textStyle={{ color: "#555" }}
                                        outline
                                        // animated
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            />
        );
    };

    renderSolarRevolution = () => {
        const { handleSubmit } = this.props;

        return (
            <Modal
                isVisible={this.state.isVisibleSolar}
                title="Revolução Solar"
                id="modal-select"
                styleContent={{ width: "50rem" }}
                children={
                    <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                        <Form role="form" onSubmit={handleSubmit(this.onSolarRevolution)} noValidate>
                            <div className="form__body">{this.renderFieldsSolar()}</div>
                            <div className="form__footer">
                                <div className="form__footer--actions">
                                    <Button
                                        text="Cancelar"
                                        type="button"
                                        rounded
                                        colors={"#f1c40f"}
                                        textStyle={{ color: "#555" }}
                                        outline
                                        onClick={this.closeForm}
                                    />
                                    <Button
                                        text="Gerar"
                                        type="submit"
                                        // style={{ width: "25%" }}
                                        rounded
                                        buttonType="primary"
                                        textStyle={{ color: "#555" }}
                                        outline
                                        // animated
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            />
        );
    };

    renderMoonRevolution = () => {
        const { handleSubmit } = this.props;
        return (
            <Modal
                isVisible={this.state.isVisibleMoon}
                title="Revolução Lunar"
                id="modal-select"
                styleContent={{ width: "50rem" }}
                children={
                    <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                        <Form role="form" onSubmit={handleSubmit(this.onMoonRevolution)} noValidate>
                            <div className="form__body">{this.renderFieldsMoon()}</div>
                            <div className="form__footer">
                                <div className="form__footer--actions">
                                    <Button
                                        text="Cancelar"
                                        type="button"
                                        rounded
                                        colors={"#f1c40f"}
                                        textStyle={{ color: "#555" }}
                                        outline
                                        onClick={this.closeForm}
                                    />
                                    <Button
                                        text="Gerar"
                                        type="submit"
                                        // style={{ width: "25%" }}
                                        rounded
                                        buttonType="primary"
                                        textStyle={{ color: "#555" }}
                                        outline
                                        // animated
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            />
        );
    };

    renderTransitsChart = () => {
        const { handleSubmit } = this.props;

        return (
            <Modal
                isVisible={this.state.isVisibleTransits}
                title="Mapa de Trânsitos diretos"
                id="modal-select"
                styleContent={{ width: "50rem" }}
                children={
                    <div className="modal-body center-text" style={{ paddingTop: 20 }}>
                        <Form role="form" onSubmit={handleSubmit(this.onTransitsRevolution)} noValidate>
                            <div className="form__body">{this.renderFieldsTransits()}</div>
                            <div className="form__footer">
                                <div className="form__footer--actions">
                                    <Button
                                        text="Cancelar"
                                        type="button"
                                        rounded
                                        colors={"#f1c40f"}
                                        textStyle={{ color: "#555" }}
                                        outline
                                        onClick={this.closeForm}
                                    />
                                    <Button
                                        text="Gerar"
                                        type="submit"
                                        // style={{ width: "25%" }}
                                        rounded
                                        buttonType="primary"
                                        textStyle={{ color: "#555" }}
                                        outline
                                        // animated
                                    />
                                </div>
                            </div>
                        </Form>
                    </div>
                }
            />
        );
    };

    renderFormUsed = () => {
        switch (this.state.formType) {
            case "selectChart":
                return this.renderSelectChart();
            case "createChart":
                return this.renderCreateChart();
            case "solarChart":
                return this.renderSolarRevolution();
            case "moonChart":
                return this.renderMoonRevolution();
            case "transitsChart":
                return this.renderTransitsChart();
            default:
                return null;
        }
    }

    render() {
        if (this.props.loading) {
            return <Loading isVisible={this.props.loading} overlay={true} />;
        }

        return (
            <section className="home">
                {this.renderCharts()}
                <div className="new-chart" onClick={() => {this.props.initializeForm("chartForm", {});this.setState({ isVisible: true, formType: "createChart" })}}>
                    <div className="fa fa-plus new-chart--icon" />
                    <span className="new-chart--text">Novo Mapa</span>
                </div>

                {this.renderFormUsed()}
            </section>
        );
    }
}

Home = reduxForm({ form: "chartForm" })(Home);

const mapStateToProps = state => {
    return {
        auth: state.auth,
        cities: state.city.list.content,
        myCharts: state.myChart,
        home: state.homePage,
        loading: state.homePage.loading
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
            reset,
            change,
            setLoading,
            getMyCharts,
            drawChart,
            saveChart,
            drawSolarRevolution,
            initializeForm,
            drawMoonRevolution,
            drawTransits,
            chartToPrint
        },
        dispatch
    )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);
